import React from 'react'
import { CiVideoOn } from 'react-icons/ci'
import { GrDocumentCsv, GrDocumentWord } from 'react-icons/gr'
import { VscFilePdf, VscFileZip, VscFile } from 'react-icons/vsc'
import pdfImage2 from '../../../../src/assets/images/PDFImage2.svg';
import videoImage from '../../../../src/assets/images/VideoImage.svg';
import { PiMicrosoftExcelLogoFill } from 'react-icons/pi';

const BYTE = 1000
const getKB = (bytes) => Math.round(bytes / BYTE)

const FileIcon = ({ children }) => {
    return <span className="text-4xl">{children}</span>
}

const FileItem = (props) => {
    const { file, children, selectedUploadType } = props
    const { type, name, size } = file
    console.log("selectedUPloadType in file item:", selectedUploadType, type);
    const renderThumbnail = () => {
        const isImageFile = type.split('/')[0] === 'image'

        if (isImageFile) {
            return (
                <img
                    className="upload-file-image"
                    src={URL.createObjectURL(file)}
                    alt={`file preview ${name}`}
                />
            )
        }
        if (type === 'video/x-matroska' || type === 'video/mp4') {
            return (
                <FileIcon>
                    <span className="w-8 h-8 inline-block">
                        <img src={videoImage} style={{margin:"6px auto"}}/>
                    </span>
                </FileIcon>
            )
        }

        if (type === 'application/zip') {
            return (
                <FileIcon>
                    <VscFileZip />
                </FileIcon>
            )
        }

        if (type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            return (
                <FileIcon>
                    <PiMicrosoftExcelLogoFill style={{color:"#2563EB"}}/>
                </FileIcon>
            )
        }
        if (type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            return (
                <FileIcon>
                    <GrDocumentWord style={{color:"#2563EB"}}/>
                </FileIcon>
            )
        }
        if (type === 'application/pdf') {
            return (
                <FileIcon>
                    <span className="w-8 h-8 inline-block">
                        <img src={pdfImage2} style={{margin:"auto"}}/>
                    </span>
                </FileIcon>
            )
        }

        return (
            <FileIcon>
                <GrDocumentCsv size={25} style={{ color: "#15803D" }} />
            </FileIcon>
        )
    }

    return (
        <div className=" w-4/5">
            <div className="flex">
                <div className="upload-file-thumbnail"><span className='p-2' style={{ backgroundColor: (selectedUploadType == "PDF" || selectedUploadType == "VIDEO") ? "#FFFFFF" : "#F0FDF4" }}>{renderThumbnail()}</span></div>
                <div className="upload-file-info w-4/5">
                    <p className="upload-file-name font-semibold w-4/5">{name}</p>
                    <span className="upload-file-size">{getKB(size) || 1} kb</span>
                </div>
            </div>
            {children}
        </div>
    )
}

export default FileItem
